import * as alerts from '@/utils/alerts';

export default {
  install(app) {
    // Make alerts available globally as $alerts
    app.config.globalProperties.$alerts = alerts;
    
    // Also make individual methods available
    app.config.globalProperties.$showSuccess = alerts.showSuccess;
    app.config.globalProperties.$showError = alerts.showError;
    app.config.globalProperties.$showWarning = alerts.showWarning;
    app.config.globalProperties.$showInfo = alerts.showInfo;
    app.config.globalProperties.$showConfirm = alerts.showConfirm;
    app.config.globalProperties.$showLoading = alerts.showLoading;
    app.config.globalProperties.$closeLoading = alerts.closeLoading;
    app.config.globalProperties.$showToast = alerts.showToast;

    // Backwards-compatible alias so existing this.$swal({...}) usages continue to work.
    // This simply forwards the options object to SweetAlert2 via showCustom.
    app.config.globalProperties.$swal = alerts.showCustom;
  }
};
